import { render, staticRenderFns } from "./bien-recu-2.vue?vue&type=template&id=281aa6f7&scoped=true&"
import script from "./bien-recu-2.vue?vue&type=script&lang=js&"
export * from "./bien-recu-2.vue?vue&type=script&lang=js&"
import style0 from "./bien-recu-2.vue?vue&type=style&index=0&id=281aa6f7&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281aa6f7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/app/components/Logo.vue').default,Header: require('/app/components/Header.vue').default,Button: require('/app/components/Button.vue').default,Footer: require('/app/components/Footer.vue').default})
